import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

/**
 * Hook to open the Stripe Customer Portal via the manage-subscription edge function.
 */
export function useManageSubscription() {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const openPortal = async () => {
    setLoading(true);
    try {
      const response = await supabase.functions.invoke('manage-subscription', {
        body: {},
      });

      if (response.error) {
        throw new Error(response.error.message || 'Failed to open billing portal');
      }

      const { portal_url } = response.data;
      if (portal_url) {
        window.location.href = portal_url;
        return portal_url;
      } else {
        throw new Error('No portal URL returned');
      }
    } catch (err) {
      console.error('[use-manage-subscription] Error:', err);
      toast({
        title: 'Error',
        description: 'Failed to open billing portal. Please try again.',
        variant: 'destructive',
      });
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { openPortal, loading };
}
